<template>
  <nav class="navbar navbar-expand-lg navbar-light navbar-home">
    <div class="container">

      <!-- Navbar Toggler for Mobile View -->
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Navbar Content -->
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">


          <li class="nav-item dropdown">
            <a class="nav-link" href="#" id="financialInfoDropdown" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              ข้อมูลบริษัท
            </a>

            <ul class="dropdown-menu shadow-dropdown" aria-labelledby="financialInfoDropdown">
              <li><a class="dropdown-item"
                  href="https://origin.co.th/corporate/about-origin-property/">เกี่ยวกับออริจิ้น</a></li>
              <li><a class="dropdown-item"
                  href="https://origin.co.th/corporate/company-history/">ความเป็นมาของออริจิ้น</a></li>
              <li><a class="dropdown-item"
                  href="https://origin.co.th/corporate/message-from-the-chairman/">สารจากประธานกรรมการบริษัท</a></li>
              <li><a class="dropdown-item"
                  href="https://origin.co.th/corporate/message-from-the-ceo/">สารจากประธานเจ้าหน้าที่บริหาร</a></li>
              <li><a class="dropdown-item" href="https://origin.co.th/corporate/organization-chart/">โครงสร้างองค์กร</a>
              </li>
              <li><a class="dropdown-item" href="https://origin.co.th/corporate/group-structure/">โครงสร้างกลุ่มบริษัท</a>
              </li>
              <li><a class="dropdown-item" href="https://origin.co.th/corporate/board-of-directors/">โครงสร้างการจัดการ</a>
              </li>
              <li><a class="dropdown-item" href="https://origin.co.th/corporate/awards-received/">รางวัลที่ได้รับ</a>
              </li>
              <li><a class="dropdown-item" href="https://origin.co.th/corporate/about-origin-property/corporate-governance/cg-policy/">การกำกับดูแลกิจการที่ดี</a>
              </li>
              <li><a class="dropdown-item" href="https://origin.co.th/corporate/about-origin-property/driving-business/sustainability-management/">การขับเคลื่อนธุรกิจเพื่อความยั่งยืน</a>
              </li>
            </ul>
          </li>


          <li class="nav-item dropdown" >
            <a class="nav-link" href="#" id="financialInfoDropdown" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              ข้อมูลทางการเงิน
            </a>

            <ul class="dropdown-menu shadow-dropdown" aria-labelledby="financialInfoDropdown">

              <li><router-link class="dropdown-item" to="/financialinfo/info">ข้อมูลสำคัญทางการเงิน</router-link>
              </li>
              <li><router-link class="dropdown-item" to="/financialinfo/statements">งบการเงิน</router-link></li>
              <li><router-link class="dropdown-item"
                  to="/financialinfo/description">คำอธิบายและการวิเคราะห์ของฝ่ายจัดการ</router-link>
              </li>
            </ul>
          </li>

          <li class="nav-item dropdown">
            <a class="nav-link" href="#" id="pricingDropdown" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              ข้อมูลราคาหลักทรัพย์
            </a>
            <ul class="dropdown-menu shadow-dropdown" aria-labelledby="pricingDropdown">
              <li><router-link class="dropdown-item" to="/stockpriceinfo/info">ราคาหลักทรัพย์</router-link></li>
              <!-- <li><router-link class="dropdown-item" to="/stockpriceinfo/retrospect">ราคาหลักทรัพย์ย้อนหลัง</router-link>
              </li>
              <li><router-link class="dropdown-item" to="/stockpriceinfo/calculator">เครื่องคำนวณการลงทุน</router-link>
              </li> -->
            </ul>
          </li>

          <li class="nav-item dropdown">
            <a class="nav-link" href="#" id="pricingDropdown" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              ข้อมูลผู้ถือหุ้น
            </a>
            <ul class="dropdown-menu shadow-dropdown" aria-labelledby="pricingDropdown">
              <li><router-link class="dropdown-item" to="/basicInfo/info">ข้อมูลพื้นฐาน</router-link></li>
              <li><router-link class="dropdown-item" to="/basicinfo/majorshareholders">รายชื่อผู้ถือหุ้นใหญ่</router-link>
              </li>
              <li><router-link class="dropdown-item" to="/basicinfo/dividendpayment">การจ่ายเงินปันผล</router-link></li>
              <li><router-link class="dropdown-item" to="/basicinfo/shareholdermeeting">การประชุมผู้ถือหุ้น</router-link>
              </li>
              <li><router-link class="dropdown-item"
                  to="/basicinfo/sharesubscription">ORI-แจ้งสิทธิและรายละเอียดการจองซื้อหุ้นสามัญเพิ่มทุน</router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="/warrantholdersinfo">ข้อมูลสำหรับผู้ถือใบสำคัญแสดงสิทธิ</router-link>
              </li>
            </ul>
          </li>

          <!-- <li class="nav-item">
            <router-link class="nav-link" to="/warrantholdersinfo">ข้อมูลสำหรับผู้ถือใบสำคัญแสดงสิทธิ</router-link>
          </li> -->

          <li class="nav-item dropdown">
            <a class="nav-link" href="#" id="pricingDropdown" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              ข้อมูลตราสารหนี้
            </a>
            <ul class="dropdown-menu shadow-dropdown" aria-labelledby="pricingDropdown">
              <li><router-link class="dropdown-item" to="/debtinfo/info">ข้อมูลตราสารหนี้</router-link></li>
              <li><router-link class="dropdown-item" to="/debtinfo/creditrating">อันดับความน่าเชื่อถือ</router-link>
              </li>
              <li><router-link class="dropdown-item" to="/debtinfo/billexchange">ข้อมูลผู้ค้าหลักทรัพย์
                  (ตั๋วแลกเงิน)</router-link></li>
            </ul>
          </li>

          <li class="nav-item dropdown">
            <a class="nav-link" href="#" id="pricingDropdown" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              ศูนย์รวมข่าวสาร
            </a>
            <ul class="dropdown-menu shadow-dropdown" aria-labelledby="pricingDropdown">
              <li><router-link class="dropdown-item" to="/newinfo/info">ข่าวแจ้งตลาดหลักทรัพย์</router-link></li>
              <li><router-link class="dropdown-item" to="/newinfo/newsmedia">ข่าวแจ้งสื่อมวลชน</router-link>
              </li>
              <li><router-link class="dropdown-item" to="/newinfo/newsprintmedia">ข่าวจากสื่อสิ่งพิมพ์</router-link>
              </li>
              <li><router-link class="dropdown-item"
                  to="/newinfo/electronicadvertising">โฆษณาทางอิเล็กทรอนิกส์</router-link>
              </li>
              <li><router-link class="dropdown-item"
                to="/calendarinfo/info">ปฏิทินนักลงทุนสัมพันธ์</router-link>
              </li>
            </ul>
          </li>

          <!-- <li class="nav-item">
            <router-link class="nav-link" to="/calendarinfo/info">ปฏิทินนักลงทุนสัมพันธ์</router-link>
          </li> -->

          <li class="nav-item dropdown">
            <a class="nav-link" href="#" id="pricingDropdown" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              เอกสารเผยแพร่
            </a>
            <ul class="dropdown-menu shadow-dropdown" aria-labelledby="pricingDropdown">
              <li><router-link class="dropdown-item" to="/publisheddocsinfo/info">56-1 One Report</router-link>
              </li>
              <li><router-link class="dropdown-item" to="/publisheddocsinfo/annualreport">รายงานประจำปี</router-link>
              </li>
              <li><router-link class="dropdown-item"
                  to="/publisheddocsinfo/sustainabilityreport">รายงานความยั่งยืน</router-link></li>
              <li><router-link class="dropdown-item" to="/publisheddocsinfo/form56-1">แบบฟอร์ม 56-1</router-link></li>
              <!-- <li><router-link class="dropdown-item"
                  to="/publisheddocsinfo/downloaddocuments">ดาวน์โหลดเอกสารนักลงทุนสัมพันธ์</router-link></li> -->
            </ul>
          </li>

          <li class="nav-item">
            <router-link class="nav-link" to="/activityinfo">กิจกรรมเอกสารนำเสนอ</router-link>
          </li>

          <li class="nav-item dropdown">
            <a class="nav-link" href="#" id="pricingDropdown" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              ข้อมูลนักวิเคราะห์
            </a>
            <ul class="dropdown-menu shadow-dropdown" aria-labelledby="pricingDropdown">
              <li><router-link class="dropdown-item" to="/analystinfo">ติดต่อนักวิเคราะห์</router-link></li>
              <li><router-link class="dropdown-item" to="/securitiesanalysis">บทวิเคราะห์หลักทรัพย์</router-link>
              </li>
            </ul>
          </li>

          <li class="nav-item dropdown">
            <a class="nav-link" href="#" id="pricingDropdown" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              สอบถามข้อมูล
            </a>
            <ul class="dropdown-menu shadow-dropdown" aria-labelledby="pricingDropdown">
              <li><router-link class="dropdown-item" to="/informationinfo">ติดต่อนักลงทุนสัมพันธ์</router-link></li>
              <li><router-link class="dropdown-item" to="/receiveemails">รับอีเมลข่าวสาร</router-link>
              </li>
            </ul>
          </li>
        </ul>

        <!-- <div class="d-flex justify-content-end align-items-center p-2">
          <div class="dropdown">
            <button class="btn btn-outline-secondary btn-sm dropdown-toggle" type="button" id="languageDropdown"
              data-bs-toggle="dropdown" aria-expanded="false">
              {{ selectedLanguageText }}
            </button>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
              <li><a class="dropdown-item" href="#" @click="selectLanguage('en')">English</a></li>
              <li><a class="dropdown-item" href="#" @click="selectLanguage('th')">ไทย</a></li>
            </ul>
          </div>
        </div> -->
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'AppNavbarMenu',
  data() {
    return {
      selectedLanguage: 'th', // Default language is Thai
    };
  },
  computed: {
    selectedLanguageText() {
      return this.selectedLanguage === 'en' ? 'English' : 'ไทย';
    }
  },
  methods: {
    selectLanguage(language) {
      this.selectedLanguage = language;
      console.log(`Language selected: ${language}`);
      // Implement additional language switching logic here, if needed
    },
  },
};
</script>

<style scoped>
.shadow-dropdown.show {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  border: none
}

.navbar-nav .nav-link {
  font-size: 0.74rem;
  position: relative;
  text-decoration: none;
  margin-right: 13px;
}


.dropdown-menu .dropdown-item {
  font-size: 0.74rem;
  text-decoration: none;
}

.navbar-nav>.nav-item>.nav-link::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: #E87D2E;
  transition: width 0.3s;
}

.navbar-nav>.nav-item>.nav-link:hover::after {
  width: 100%;
}

.navbar-toggler {
  margin-left: auto;
  /* Push it to the right */
}

a.router-link-active,
a.router-link-exact-active {
  text-decoration: none;
  color: #E87D2E;
}

.navbar-home{
  justify-self: center;
}


@media (max-width: 990px) {
  .navbar-home {
    /* Add mobile-specific styling */
    justify-self: auto;  /* Example: align navbar to the start for mobile */
  }
}
</style>